/*eslint-disable*/
export default {
    map: require('./modules/map.json'),
    user: require('./modules/user.json'),
    miles: require('./modules/miles.json'),
    points: require('./modules/points.json'),
    common: require('./modules/common.json'),
    errors: require('./modules/errors.json'),
    olympiads: require('./modules/olympiads.json'),
    timetable: require('./modules/timetable.json'),
    historyTable: require('./modules/historyTable.json'),
    conversations: require('./modules/conversations.json'),
    profiles: require('./modules/profiles.json'),
    dashboard: require('./modules/dashboard.json'),
    timeMeasurement: require('./modules/timeMeasurement.json'),
    elements: require('./modules/elements.json'),
    declination: require('./modules/declination.json'),
    progress: require('./modules/progress.json'),
    fleshCardsPreview: require('./modules/fleshCardsPreview.json'),
    mapModal: require('./modules/mapModal.json'),
    trainer: require('./modules/trainer.json'),
    games: require('./modules/games.json'),
    list: require('./modules/list.json'),
    fields: require('./modules/fields.json'),
    router: require('./modules/router.json'),
    grade: require('./modules/grade.json'),
    homework: require('./modules/homework.json'),
    school: require('./modules/school.json'),
    support: require('./modules/support.json'),
    auth: require('./modules/auth.json'),
    templates: require('./modules/templates.json'),
    modal: require('./modules/modal.json'),
    course: require('./modules/course.json'),
    couples: require('./modules/couples.json'),
    mapConversations: require('./modules/mapConversations.json'),
    detectiveStoryConversations: require('./modules/detectiveStoryConversations.json'),
    detective: require('./modules/detective.json'),
    detectiveModal: require('./modules/detectiveModal.json'),
    billing: require('./modules/billing.json'),
    presentations: require('./modules/presentations.json'),
    battle: require('./modules/battle.json'),
    achievements: require('./modules/achievements.json')
}
